import React from "react";
import styles from "./index.module.scss";
import { ChevronDown } from "lucide-react";
import { INSTITUTE } from "../../constants/applicationConstants";
import MultiSelectDropdown from "../MultiSelectDropdown";
import DateRangePicker from "../DateRangePicker";

const FilterHeader = ({
  applicationId,
  instituteFilter = { SMTI: true, NMTI: true },
  onInstituteFilterChange,
  selectionRange = { startDate: null, endDate: null },
  onFromDateChange,
  onToDateChange,
  onResetDate
}) => {

  return (
    <div className={styles.header}>
      <div className={styles.headerRightSide}>
        {/* State Selector - Disabled Dropdown */}
        {applicationId && (
          <div className={styles.selectWrapper}>
            <div className={`${styles.selectBtn} ${styles.disabled}`}>
              {applicationId.toUpperCase()} <ChevronDown size={18} />
            </div>
          </div>
        )}

        {/* Institute Filter - Multi-Select Dropdown */}
        <MultiSelectDropdown
          options={INSTITUTE}
          selectedValues={instituteFilter}
          onChange={onInstituteFilterChange}
          placeholder="Select Institute"
        />

        {/* Date Range Picker */}
        <DateRangePicker
          selectionRange={selectionRange}
          onFromDateChange={onFromDateChange}
          onToDateChange={onToDateChange}
          onResetDate={onResetDate}
        />       
      </div>
    </div>
  );
};

export default FilterHeader;

